import React from 'react';
import { useDispatch } from 'react-redux';
import CancelToDetails from '../../../../controllers/CancelToDetails';
import { actionCreators, sliceKeys } from '../../../../model';

const { newConfigPageReset } = actionCreators[sliceKeys.newConfigPage];

const CancelCreate = () => {
  const dispatch = useDispatch();

  const resetFn = () => dispatch(newConfigPageReset());

  return <CancelToDetails resetFn={resetFn} />;
};

export default CancelCreate;
